export function init() {
	
	// Wizard prompt ---------------------------------------------------------------------------------- //

	const toggleWizard = () => {
		document.querySelector('.wizard').classList.toggle('-visible');
		document.querySelector('.overlay').classList.toggle('-visible');
	}

	if (document.querySelector('.-open-wizard')) {
		const openWizardLinks = document.querySelectorAll('.-open-wizard');
		openWizardLinks.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				toggleWizard();
			});
		});

		document.querySelector('.wizard .close-wizard').addEventListener('click', (e) => {
			e.preventDefault();
			toggleWizard();
		});
	}


	// Wizard functionality --------------------------------------------------------------------------- //

	const wizardButtons = document.querySelectorAll('.wizard .btn.continue');
	wizardButtons.forEach((el) => {
		el.addEventListener('click', (e) => {
			e.preventDefault();
			const continueTo = e.target.dataset.continueto;

			const allQuestions = document.querySelectorAll('.wizard .question');
			allQuestions.forEach((el) => {
				el.classList.remove('-active', '-visible');
			});

			document.querySelector('.wizard .question[data-questionid="' + continueTo + '"]').classList.add('-active');
			setTimeout(() => {
				document.querySelector('.wizard .question[data-questionid="' + continueTo + '"]').classList.add('-visible');
			}, 20);
		});
	});

}